import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { FaCheckCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const scrollToTop = () => {
    window.scrollTo(0, 0);
};



export default function Full_stack_courses() {
    useEffect(() => {
        scrollToTop();
    }, []);
    const courseData = [

        {  id: 2,
            image: "img/Institute/full stack.jpg",
            title: "FULL STACK COURSES",
            description: 'Build expertise in full-stack development from frontend to backend.',
            price: "15000",
            duration:'4 months',
            insideHeading: "FULL STACK COURSES",
            videoSrc: "img/Institute/full stack.jpg"
        },
        {  id: 3,
            image: "img/Institute/mern.jpg",
            title: "MERN STACK COURSES",
            description: "MongoDB, Express, ReactJS, Node.js.",
            price: "18000",
            duration:'5-6 months',
            insideHeading: "MERN STACK COURSES",
            videoSrc: "img/Institute/mern.jpg"
        },
        {  id: 4,
            image: "img/Institute/mean.jpg",
            title: "MEAN STACK COURSES",
            description: "MongoDB, Express, AngularJS , Node.js.",
            price: "18000",
            duration:'5-6 months',
            insideHeading: "MEAN STACK COURSES",
            videoSrc: "img/Institute/mean.jpg"
        },
      
        
        { id: 8,
            image: "img/Institute/python full stack.jpg",
            title: "PYTHON FULL STACK",
            description: "Python & Django Framework Course for candidates willing to embark on full-stack development",
            price: "18000",
            duration:'5-6 months',
            insideHeading: "PYTHON FULL STACK",
            videoSrc: "img/Institute/python full stack.jpg"
        },
       
      
        { id: 15,
            image: "img/Institute/php.jpg",
            title: "PHP FULL STACK",
            description: "Master PHP and full-stack web development, from frontend to backend.",
            price: "18000",
            duration:'3 months',
            insideHeading: "PHP FULL STACK",
            videoSrc: "img/Institute/php.jpg"
        },
        

    ];


    return (
        <>
            <div className="bg-primary hero-header">
                <div className="jumbotron page-header jumbotron-fluid position-relative overlay-bottom" style={{ marginBottom: "20px", height: "550px" }}>
                    <div className="container pt-3 item">
                        <div className="row g-5 pt-5">
                            <div className="col-lg-12" style={{ textAlign: "center", marginTop: "178px" }}>
                                <h1 className="text-white mt-1 mb-3 animated slideInRight">Learn From ABITM Institute</h1>
                                <h1 className=" text-white mb-5 animated slideInRight">Full Stack Courses</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card-area">
                {courseData.map((card, index) => (
                    <div key={index} className="card">
                        <div className="flip-card">
                            <div className="flip-card__container">
                                <div className="card-front">
                                    <div className='card-front__tp'>
                                        <img src={card.image} alt={card.insideHeading} className="card-front__image" />
                                    </div>
                                    <div className="card-front__bt">
                                        <p className='card-front__text-view'>{card.title}</p>
                                    </div>
                                </div>
                                <div className="card-back">
                                    <img className="" src={card.videoSrc} alt={`${card.title} video`} />
                                </div>
                            </div>
                        </div>
                        <div className="inside-page">
                            <div className="inside-page__container">
                                <h3 className='inside-page__heading'>{card.insideHeading}</h3>
                                <p className="inside-page__text">
                                    {card.description}
                                    <br />
                                    <strong>Price:</strong> ₹{card.price}
                                    <br />
                                    <strong>Duration:</strong> {card.duration}
                                </p>
                                <Link to={`/course_details/${card.id}`} className="inside-page__btn inside-page__btn--camping">Learn More</Link>

                            </div>


                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}